
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { 
  CheckCircle2, 
  Clock, 
  AlertCircle, 
  PauseCircle, 
  CircleDashed,
  LucideIcon 
} from "lucide-react"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Map of column IDs to their respective icons
export const iconMap: Record<string, LucideIcon> = {
  "to-do": CircleDashed,
  "in-progress": Clock,
  "blocked": AlertCircle,
  "in-review": PauseCircle,
  "done": CheckCircle2,
}
